import React from 'react';

export interface ILazyImageProps {
    src?: string;
    srcSet?: string;
    sizes?: string;
    alt?: string;
    immediate?: boolean;
    onLoad?: () => void;
    onError?: () => void;
    className?: string;
}
export const LazyImage: React.FC<ILazyImageProps> = ({ src, srcSet, sizes, alt, className, immediate, onLoad, onError }: ILazyImageProps): JSX.Element => {
    const onImageError = () => {
        if (typeof onError === 'function') {
            onError();
        }
    };

    const onImageLoad = () => {
        if (typeof onLoad === 'function') {
            onLoad();
        }
    };

    const sharedProps = {
        src,
        srcSet,
        sizes,
        alt,
        className,
        onLoad: onImageLoad,
        onError: onImageError
    };

    // We use loading="lazy" in browsers that support it - if not, we just load it. Sure, Safari gets the
    // short end of the stick (as long as it doesn't support this) - but as long as SSR markup has to be
    // universal we must choose which way to roll. loading="lazy" is the future, so we go with this in
    // stead of IntersectionObserver-driven polyfills.
    return <img {...sharedProps} loading={immediate ? 'eager' : 'lazy'} />;
}
